/**
 * These utils are lifted from `@sindlesorhus/is`
 */

export function isNull(value: unknown): value is null {
  return value === null
}

export function isUndefined(value: unknown): value is undefined {
  return value === undefined
}

export function isObject(value: unknown): value is object {
  return !isNull(value) && (typeof value === 'object' || isFunction(value))
}

export function isEmptyString(value: unknown): value is '' {
  return isString(value) && value.length === 0
}

export function isNullOrUndefined(value: unknown): value is null | undefined {
  return isNull(value) || isUndefined(value)
}

// biome-ignore lint/complexity/noBannedTypes: keep the original code
export function isFunction(value: unknown): value is Function {
  return typeof value === 'function'
}

export function isString(value: unknown): value is string {
  return typeof value === 'string'
}

export function isArray<T = unknown>(
  value: unknown,
  assertion?: (value: T) => value is T
): value is T[] {
  if (!Array.isArray(value)) {
    return false
  }

  if (!isFunction(assertion)) {
    return true
  }

  // @ts-expect-error
  return value.every(element => assertion(element))
}

/**
 * @note Does’t test isMap or isSet
 */
export function isEmptyObject<Key extends keyof any = string>(
  value: unknown
): value is Record<Key, never> {
  return (
    isObject(value) &&
    // Disabled because they pull in a lot of crap, and I’m okay with this
    // !isMap(value) &&
    // !isSet(value) &&
    Object.keys(value).length === 0
  )
}
